import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import SellerOrdersComponent from "./views/SellerOrdersList";

const SellerOrders: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <SellerOrdersComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Seller Orders",
          description: "seller orders report section name"
        })}
      />

      <Routes>
        <Route path={""} element={<SellerOrders />} />
      </Routes>
    </>
  );
};

export default Component;
